import { gql } from 'apollo-angular';

const GET_RESPONSE_RFP_STATISTICS = gql`
  query getRfpStatistics($organizationId: Long) {
    rfpStatistics(organizationId: $organizationId) {
      submittedCount
      sellerResponseDueLaterThanTenDaysCount
      sellerResponseDueWithinSixToTenDaysCount
      sellerResponseDueWithinOneToFiveDaysCount
    }
  }
`;

export default GET_RESPONSE_RFP_STATISTICS;
